/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';

import { FEET_TO_METERS_MULTIPLIER } from '../../app-constants';

declare var $: any;

@Component({
  selector: 'app-set-z-coordinate-dialog',
  templateUrl: './set-z-coordinate-dialog.component.html'
})
export class SetZCoordinateDialogComponent {

  @Output()
  setZCoordinate = new EventEmitter<number>();

  mZCoordinate: number = null;
  mMeasurementType = MeasurementType.FEET;

  mId = 'setZCoordinateDialog';
  mDialogHeaderId = 'setZCoordinateDialogHeader';
  mAvailableMeasurementTypes = [MeasurementType.FEET, MeasurementType.YARDS, MeasurementType.MILES, MeasurementType.METERS, MeasurementType.KILOMETERS];


  show(): void {
    console.log("show()");
    this.mMeasurementType = MeasurementType.FEET;
    this.mZCoordinate = null;
    $(`#${this.mId}`).modal("show");
  }

  hide(): void {
    console.log("hide()");
    $(`#${this.mId}`).modal("hide");
  }

  setZCoordinateClicked(): void {
    console.log("setScaleClicked() - Value: " + this.mZCoordinate + ", Type: " + this.mMeasurementType);
    const valueInMeters = this.getValueInMeters();
    if (valueInMeters != null) {
      this.setZCoordinate.emit(valueInMeters);
      this.hide();
    } else {
      this.setZCoordinate.emit(0);
      this.hide();
    }
  }

  getValueInMeters(): number {
    if (this.mZCoordinate != null && this.mZCoordinate > 0 && this.mMeasurementType != null) {
      switch (this.mMeasurementType) {
        case MeasurementType.FEET: {
          return this.mZCoordinate * FEET_TO_METERS_MULTIPLIER;
        }
        case MeasurementType.YARDS: {
          return this.mZCoordinate * 0.9144;
        }
        case MeasurementType.MILES: {
          return this.mZCoordinate * 1609.34;
        }
        case MeasurementType.METERS: {
          return this.mZCoordinate;
        }
        case MeasurementType.KILOMETERS: {
          return this.mZCoordinate / 1000;
        }
      }
    }
    return null;
  }

}

export enum MeasurementType {
  FEET = 'FEET',
  YARDS = 'YARDS',
  MILES = 'MILES',
  METERS = 'METERS',
  KILOMETERS = 'KILOMETERS'
}
